import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { MatInput } from "@angular/material/input";
import { Observable } from "rxjs";
import { CreatePriorityAttributes } from "../../../../_models/priority.interface";
import { FullProjectHash } from "../../../../_models/project.interface";
import { ProjectService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";

@Component({
  selector: "hawk-edit-priority-modal",
  imports: [FormsModule, ReactiveFormsModule, MatInput],
  templateUrl: "./edit-priority-modal.component.html",
  standalone: true,
  styleUrls: ["./edit-priority-modal.component.scss"],
})
export class EditPriorityModalComponent extends FormModalComponent<CreatePriorityAttributes, FullProjectHash> {
  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  constructor(private projectService: ProjectService) {
    super();
  }

  override formGroupToDBInput(): CreatePriorityAttributes {
    return {
      id: this.formGroup.controls["id"].value,
      name: this.formGroup.controls["name"].value,
      color: this.formGroup.controls["color"].value,
      days: this.formGroup.controls["days"].value,
      hours: this.formGroup.controls["hours"].value,
      material_return: this.formGroup.controls["material_return"].value,
      priority_idx: this.formGroup.controls["priority_idx"].value,
      sla_type: this.formGroup.controls["sla_type"].value,
      telephone_dispatching: this.formGroup.controls["telephone_dispatching"].value,
      project_id: this.formGroup.controls["project_id"].value,
    };
  }

  override getDBCallObservable(create_priority_attributes: CreatePriorityAttributes): Observable<FullProjectHash> {
    return this.projectService.updateProjectPriority(
      create_priority_attributes.project_id,
      create_priority_attributes.id,
      create_priority_attributes,
    );
  }
}
